/* eslint-disable no-nested-ternary */
/**
 * Menghitung jarak antara dua titik geografis menggunakan formula Haversine.
 * @returns {number} Jarak dalam meter.
 */
export function calculateDistance(lat1, lon1, lat2, lon2) {
  if (!lat1 || !lon1 || !lat2 || !lon2) return 0;
  const toRadians = (degree) => degree * (Math.PI / 180);
  const R = 6371e3; // Radius Bumi dalam meter

  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);

  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
    + Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2))
    * Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c; // Jarak dalam meter
}

/**
 * Menghitung arah (bearing/heading) dari titik 1 ke titik 2.
 * @returns {number} Arah dalam derajat (0-360).
 */
export function calculateHeading(lat1, lon1, lat2, lon2) {
  if (!lat1 || !lon1 || !lat2 || !lon2) return 0;
  const toRadians = (degree) => degree * (Math.PI / 180);
  const latRad1 = toRadians(lat1);
  const latRad2 = toRadians(lat2);
  const dLon = toRadians(lon2 - lon1);

  const y = Math.sin(dLon) * Math.cos(latRad2);
  const x = Math.cos(latRad1) * Math.sin(latRad2)
    - Math.sin(latRad1) * Math.cos(latRad2) * Math.cos(dLon);

  const brng = Math.atan2(y, x);
  return ((brng * (180 / Math.PI)) + 360) % 360;
}

/**
 * Mengonversi format desimal ke Derajat, Menit, Detik (DMS).
 * @returns {string} Koordinat dalam format DMS.
 */
export function convertDecimalToDMS(decimal, isLatitude) {
  if (typeof decimal === 'undefined' || decimal === null) return '';
  const degrees = Math.floor(Math.abs(decimal));
  const minutesDecimal = (Math.abs(decimal) - degrees) * 60;
  const minutes = Math.floor(minutesDecimal);
  const seconds = Math.round((minutesDecimal - minutes) * 60);

  const direction = decimal >= 0
    ? (isLatitude ? 'N' : 'E')
    : (isLatitude ? 'S' : 'W');

  return `${degrees}°${minutes}'${seconds}''${direction}`;
}

/**
 * Memformat durasi dari jam desimal menjadi format HH:MM:SS.
 * @returns {string} Durasi dalam format HH:MM:SS.
 */
export function formatDuration(duration) {
  if (Number.isNaN(duration) || duration < 0) return '00:00:00';
  const hours = Math.floor(duration);
  const minutes = Math.floor((duration - hours) * 60);
  const seconds = Math.round(((duration - hours) * 60 - minutes) * 60);

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
